import PageProtectedLayout from '../../../../components/Page/PageProtectedLayout';
import MicronutrientsHealth from './Micronutrientshealth';
import { useTranslation } from '../../../../language';



export default function NutrientHealthWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_micronutrients_health')}
      headlineFontWeight={500}
      >

    <MicronutrientsHealth />
   
      
    </PageProtectedLayout>

  );
}